var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1494 2.76815C22.5629 2.20759 21.8667 1.76292 21.1003 1.45954C20.334 1.15615 19.5126 1 18.6831 1C17.8535 1 17.0321 1.15615 16.2658 1.45954C15.4994 1.76292 14.8032 2.20759 14.2167 2.76815L12.9997 3.93095L11.7826 2.76815C10.5981 1.6364 8.99152 1.00059 7.31633 1.00059C5.64114 1.00059 4.03455 1.6364 2.85001 2.76815C1.66547 3.89989 1 5.43487 1 7.03541C1 8.63594 1.66547 10.1709 2.85001 11.3027L4.06705 12.4655L12.9997 21L21.9323 12.4655L23.1494 11.3027C23.7361 10.7424 24.2015 10.0771 24.519 9.34495C24.8366 8.61276 25 7.82796 25 7.03541C25 6.24285 24.8366 5.45806 24.519 4.72587C24.2015 3.99368 23.7361 3.32844 23.1494 2.76815V2.76815Z",
    stroke: "#383733",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.50950b6acf6871ce70f5fc5e868709f3.svg";
export { ForwardRef as ReactComponent };